import ModalCore from "./modal-core";

import * as Api from './api'
import * as Mixins from './mixins'
import * as Utils from './utils'
import * as Components from './components'

export {Api, Mixins, Utils, Components}
export * from "./register-components";
export * from "./constants";
export * from "./init-vue";
export * from "./init-i18n";

const BvmCore = {
  // The install method is called when this library is installed with `Vue.use(BvmCore)`.
  // It takes the global Vue object (automatically given) as well as user-defined options like:
  // `Vue.use(BvmCore, { "option-a": "Value A" })`
  install(Vue, options) {
    // If modal is already instantiated on this Vue instance, return
    if (Vue.prototype.$bvmModal) {
      return;
    }

    // Init Modal Core with methods
    const modalCore = ModalCore(Vue, options);

    // Register Modal Core in the current Vue instance, callable as `this.$bvmModal`
    Object.defineProperty(Vue.prototype, "$bvmModal", {
      get: function() {
        // The "this" scope is the scope of the component that calls this.$bvmModal
        const caller = this;

        // The this.$bvmModal can be called only from inside the vue components so this check is not really needed...
        if (caller instanceof Vue) {
          const root = caller.$root;

          if (!modalCore.context.root) {
            modalCore.setDynamicModalContainer(root);
          }
        }

        return modalCore;
      }
    });
  }
};

export default BvmCore;
